import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';


let _venueContacts = [];

let VenueContactStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    
    getAll: function() {
         return _venueContacts.filter(function(e) { return e !== undefined; });
    },
    getByVenue: function(id) {
        return _venueContacts.filter(function(e) { return e !== undefined && e.venueId == id; });
    },
    add: function(entity) {
        if (!!entity.id && !!entity.venueId) {
            let index = _venueContacts.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.venueId == entity.venueId; });
            if (0 <= index) {
                _venueContacts[index] = entity;
            } else {
                _venueContacts.push(entity);
            }
        }
    },
    remove: function(id, venueId) {
        let index = _venueContacts.findIndex(function(e) { return e !== undefined && e.id == id && e.venueId == venueId; });
        if (0 <= index) {
            delete _venueContacts[index];
        }
    }

});

VenueContactStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.VENUE_CONTACT_LIST:
            action.data.forEach(VenueContactStore.add);
            VenueContactStore.emitChange();
            break;

        case ActionTypes.VENUE_CONTACT_ADD:
            VenueContactStore.add(action.data);
            VenueContactStore.emitChange();
            break;

        case ActionTypes.VENUE_CONTACT_ADD_ERROR:
            VenueContactStore.emitChange();
            break;

        case ActionTypes.VENUE_CONTACT_REMOVE:
            if (!!action.data.id && !!action.data.venueId && !!action.data.deleted) {
                VenueContactStore.remove(action.data.id, action.data.venueId);
            }
            VenueContactStore.emitChange();
            break;

        case ActionTypes.VENUE_CONTACT_REMOVE_ERROR:
            VenueContactStore.emitChange();
            break;


        default:
            break;

    }

});

export default VenueContactStore;
